import React from 'react';
import { Badge } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ChatIcon from '@mui/icons-material/Chat';
import PeopleIcon from '@mui/icons-material/People';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import '../../styles/ChatSidebar.css';

export default function ChatSidebar({ activeTab, setActiveTab, unreadNotifications = 0, pendingRequests = 0 }) {
  const navigate = useNavigate();

  return (
    <aside className="rv-sidebar-chat">
      <button
        className="rv-sidebar-chat__back"
        onClick={() => navigate('/dashboard')}
        title="Back to Dashboard"
      >
        <ArrowBackIcon sx={{ marginRight: '6px', fontSize: '1rem' }} />
        Dashboard
      </button>
      <nav className="rv-sidebar-chat__nav" aria-label="Communications navigation">
        <button
          className={`rv-sidebar-chat__button ${
            activeTab === 'notifications' ? 'rv-sidebar-chat__button--active' : ''
          }`}
          onClick={() => setActiveTab('notifications')}
        >
          <Badge 
            color="secondary" 
            badgeContent={unreadNotifications} 
            invisible={unreadNotifications === 0}
            sx={{ '& .MuiBadge-badge': { position: 'static', transform: 'none', marginLeft: '8px' } }}
          >
            <NotificationsIcon sx={{ marginRight: '8px' }} />
            NOTIFICATIONS
          </Badge>
        </button>

        <button
          className={`rv-sidebar-chat__button ${
            activeTab === 'requests' ? 'rv-sidebar-chat__button--active' : ''
          }`}
          onClick={() => setActiveTab('requests')}
        >
          <Badge
            color="secondary"
            badgeContent={pendingRequests}
            invisible={pendingRequests === 0}
            sx={{ '& .MuiBadge-badge': { position: 'static', transform: 'none', marginLeft: '8px' } }}
          >
            <PersonAddIcon sx={{ marginRight: '8px' }} />
            REQUESTS
          </Badge>
        </button>

        <button
          className={`rv-sidebar-chat__button ${
            activeTab === 'chats' ? 'rv-sidebar-chat__button--active' : ''
          }`}
          onClick={() => setActiveTab('chats')}
        >
          <ChatIcon sx={{ marginRight: '8px' }} />
          CHATS
        </button>

        <button
          className="rv-sidebar-chat__button rv-sidebar-chat__button--disabled"
          disabled
          title="Coming soon"
        >
          <PeopleIcon sx={{ marginRight: '8px' }} />
          FRIENDS
        </button>

        <button
          className="rv-sidebar-chat__button rv-sidebar-chat__button--disabled"
          disabled
          title="Coming soon"
        >
          <HelpOutlineIcon sx={{ marginRight: '8px' }} />
          HELP DESK
        </button>
      </nav>
    </aside>
  );
}
